import jsonp from "jsonp";
import { useEffect, useState } from "react";
import apiService from "../../services/apiService";
import constants from "../../shared/constants";
import Header from "../shared/Header";
import PlayersTable from "../shared/PlayersTable";
import TeamsTable from "../shared/TeamsTable";
import dummyData from "../../shared/dummyData.json";
import LandingPageContent from "./landing/LandingPageContent";
import Footer from "../shared/Footer";

const LandingPage = () => {
  const [FPLData, setFPLData] = useState(dummyData);

  // useEffect(() => {
  //   const url = `https://json2jsonp.com/?url=${constants.endpoints.BOOTSTRAP_STATIC}`;
  //   const cbfunc = (data) => data;
  //   jsonp(
  //     url,
  //     {
  //       name: "cbfunc",

  if (!FPLData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="">
      <Header />
      <main>
        <div className="pt-16 w-full bg-gray-100">
          <LandingPageContent />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
